// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-398dc275] {\n  padding: 10px;\n}\n.pagination[data-v-398dc275] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin: 10px 0;\n}\n.pagination__total[data-v-398dc275] {\n  margin-right: 12px;\n  font-size: 13px;\n  font-weight: normal;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
